import { forwardRef, InputHTMLAttributes } from "react";
import { Typography } from "components/Typography";
import styled from "styled-components";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  title?: string;
}

const Wrapper = styled.div`
  margin-bottom: 0.25rem;
  @media(min-width:800px){ 
  margin-bottom: 1rem;
  }
`;
const Input = styled.input` 
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  line-height: 1.5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0m;
  box-sizing: border-box;
  font-size:1rem;  
`;
const StyledTypography = styled(Typography)`
  margin-bottom: 0.25rem;
  @media(min-width:800px) {
    margin-bottom: 0.75rem;
  }
`;

export const TextField = forwardRef<HTMLInputElement, IProps>(
  ({ title, ...props }, ref) => {
    return (
      <Wrapper>
        <StyledTypography variant="body">{title}</StyledTypography>
        <Input ref={ref} {...props} />
      </Wrapper>
    );
  }
);
